import React, { FC } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'

import styles from './styles.module.scss'

interface IProps {
  info: { title: string, description: string, key: number }
  changeActiveItem: (key: number | null) => void
}

export const HeadsetInfoItem: FC<IProps> = ({ info, changeActiveItem }) => {
  const onMouseOver = () => {
    changeActiveItem(info.key)
  }

  const onMouseLeave = () => {
    changeActiveItem(null)
  }

  return (
    <div className={styles.headsetInfoItem}
         onMouseOver={onMouseOver}
         onMouseLeave={onMouseLeave}
         onTouchStart={onMouseOver}
         onTouchEnd={onMouseLeave}>
      <div className={styles.title}>{info.title}</div>
      <div className={styles.description}>{info.description}</div>
    </div>
  )
}
